<template>
  <v-app style="background: #F4FAF5 !important">
    <v-main>
      <maintenance-screen v-if="maintenanceMode" />
      <router-view v-else />
    </v-main>

    <!-- Modal de actualización de versión (solo se muestra en reload loop) -->
    <modal-version-update
      v-model="showUpdateModal"
      :version-info="versionInfo"
      :persistent="isInReloadLoop"
      @update="handleUpdate"
      @dismiss="handleDismiss"
    />
  </v-app>
</template>

<script setup>
import { useVersionCheck } from '@/composables/useVersionCheck';
import { useFeatureFlag } from '@/composables/useFeatureFlag';
import { FEATURE_FLAGS } from '@/config/featureFlags';
import { featureFlagsState } from '@/utils/featureFlags';
import ModalVersionUpdate from '@/components/modals/ModalVersionUpdate.vue';
import MaintenanceScreen from '@/components/maintenance/MaintenanceScreen.vue';

// Configurar verificación de versiones
const {
  showUpdateModal,
  versionInfo,
  isInReloadLoop,
  handleUpdate,
  handleDismiss
} = useVersionCheck();

// Mantenimiento de todo el sistema (flag de LaunchDarkly, llega por streaming)
const maintenanceMode = useFeatureFlag(FEATURE_FLAGS.MAINTENANCE_MODE.key);

// Mientras dura el mantenimiento el guard no hidrata datos y las páginas no se
// montan; al terminar se recarga para entrar con el estado completo (y con la
// versión nueva si hubo despliegue).
// Solo cuenta un mantenimiento visto con LaunchDarkly ya inicializado: antes de eso
// el SDK puede aplicar un valor viejo de su caché y corregirlo enseguida, y el guard
// todavía no ha dejado pasar ninguna navegación sin hidratar
let maintenanceSeenAfterInit = false;
watch([maintenanceMode, () => featureFlagsState.ready], ([isOn, ready]) => {
  if (isOn && ready) {
    maintenanceSeenAfterInit = true;
  } else if (!isOn && maintenanceSeenAfterInit) {
    window.location.reload();
  }
});
</script>
